import { Component } from '@angular/core';

@Component({
  selector: 'app-referee-dashboard',
  templateUrl: './referee-dashboard.component.html',
  styleUrl: './referee-dashboard.component.scss'
})
export class RefereeDashboardComponent {}
